module.exports = __webpack_public_path__ + "img/dy_logo.347a143d.png";